export default theme => ({
    adaptable: {
        [theme.breakpoints.only('xs')]: {
            '&.hideExtraSmall': {
                display: 'none !important',
            },
        },
        [theme.breakpoints.only('sm')]: {
            '&.hideSmall': {
                display: 'none !important',
            },
        },
        [theme.breakpoints.only('md')]: {
            '&.hideMedium': {
                display: 'none !important',
            },
        },
        [theme.breakpoints.only('lg')]: {
            '&.hideLarge': {
                display: 'none !important',
            },
        },
        [theme.breakpoints.up('sm')]: {
            '&.hideFromSmallUp': { display: 'none !important' },
        },
        [theme.breakpoints.up('md')]: {
            '&.hideFromMediumUp': { display: 'none !important' },
        },
        [theme.breakpoints.down('sm')]: {
            '&.hideFromSmallDown': { display: 'none !important' },
        },
        [theme.breakpoints.down('md')]: {
            '&.hideFromMediumDown': { display: 'none !important' },
        },
        [theme.breakpoints.down('lg')]: {
            '&.hideFromLargeDown': { display: 'none !important' },
        },
    },
});
